import { useState } from "react";
import CarInfoTypeAddEdit from "./CarInfoTypeAddEdit";
import Button from "../../ui/Button";
import { AddIcon, DeleteIcon, EditIcon } from "../../utils/icon.utils";
import Table from "../../ui/Table/Table";
import { GroupBtn } from "../../ui/GroupBtn";
import {
  useDeleteCarInfoTypeMutation,
  useGetAllCarInfoTypeQuery
} from "../../utils/carInfoType.utils";
import { tableIndex } from "../../utils/table.utils";
import { onConfirm } from "../../utils/sweetAlert.utils";
import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import { useAppPermissions } from "../../utils/app.utils";
import { arrayMap } from "../../utils/array.utils";

export default function CarInfoTypePage() {
  const pageSize = 10;
  const appPermissions = useAppPermissions();
  const carInfoTypePermissions = { ...appPermissions?.carInfoType };
  const [currentPage, setCurrentPage] = useState(1);
  const [editItem, setEditItem] = useState(null);

  const [modal, setModal] = useState(false);

  const toggle = () => {
    if (modal) {
      setEditItem(null);
    }
    setModal((prev) => !prev);
  };

  const { loading, data } = useGetAllCarInfoTypeQuery({
    query: `?page=${currentPage}&size=${pageSize}`
  });

  const { loading: deleting, deleteCarInfoType } = useDeleteCarInfoTypeMutation([
    "deleteCarInfoType"
  ]);

  const totalPage = data?.last_page === 1 && data?.total === 0 ? 0 : data?.last_page;

  const breadCrumbs = [
    {
      name: "Car",
      link: "/car"
    },
    {
      name: "Car Info Type"
    }
  ];

  const thead = ["#", "Name", "Slug", "Action"];

  const tbody =
    arrayMap(data?.data, (item, index) => ({
      "#": tableIndex(index, currentPage, pageSize),
      Name: item?.name ?? "-",
      Slug: item?.slug ?? "-",
      ...item
    })) || [];

  const ActionComponent = ({ data }) => {
    const handleEdit = (item) => {
      setEditItem(item);
      toggle();
    };

    const handleDelete = async (item) => {
      const { isConfirmed } = await onConfirm();
      if (isConfirmed) {
        await deleteCarInfoType(item?.id);
      }
    };
    let btns = [];

    if (carInfoTypePermissions?.delete) {
      btns.push({
        icon: DeleteIcon,
        onClick: () => handleDelete(data),
        color: "danger"
      });
    }

    if (carInfoTypePermissions?.update) {
      btns.push({
        icon: EditIcon,
        onClick: () => handleEdit(data),
        color: "primary"
      });
    }

    return <GroupBtn btns={btns} justify="start" />;
  };

  const isLoading = loading || deleting;

  return (
    <PageLayout
      title="Car Info Type"
      subTitle={`Total: ${data?.total ?? 0}`}
      breadCrumbs={breadCrumbs}>
      {carInfoTypePermissions?.create && (
        <div className="text-end">
          <Button color="primary" icon={AddIcon} name="Create Car Info Type" onClick={toggle} />
        </div>
      )}

      {loading ? "Loading..." : ""}

      <Table
        thead={thead}
        tbody={tbody}
        action={ActionComponent}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPage={totalPage}
      />

      {modal && <CarInfoTypeAddEdit modal={modal} toggle={toggle} editItem={editItem} />}
      {<Loading loading={isLoading} />}
    </PageLayout>
  );
}
